module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }